import type { ReactNode } from 'react'
import { useColors } from '../../hooks/useColors'

const TABLE_SHADOW = '0px 2px 8px rgba(0,0,0,0.04)'

export default function OrdersTable({ children }: { children: ReactNode }) {
  const colors = useColors()
  return (
    <section style={{ margin: '16px 32px', background: colors.bgCard, borderRadius: '16px', boxShadow: TABLE_SHADOW, overflow: 'hidden' }}>
      {children}
    </section>
  )
}
